export default __webpack_public_path__ + "static/media/test.9b87404c.glb";